import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Modal as MaterialModal } from '@material-ui/core';

import { Animation } from 'components'
import * as actionCreators from 'store/actions';

const FlexContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 1300;
    outline: none;
`

const AbsoluteContainer = styled.div`
    position: absolute;
    top: ${props => props.y};
    left: ${props => props.x};
    -webkit-transform: ${props => `translate(-${props.x}, 0)`};
    transform: ${props => `translate(-${props.x}, 0})`};
    z-index: 1300;
    transform-origin: top;
    outline: none;
`

const defaultStyle = {
    // backgroundColor: 'var(--secondary-color)',
    backgroundColor: '#000',
    opacity: '50%',
    cursor: 'pointer'
}

const Modal = props => {
    const {
        onClose,
        styles,
        x,
        y,
        onEsc // To override for ItemModal in Calendar view that is not triggering via setModal
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)
    const dispatch = useDispatch();
    const inputID = useSelector(state => state.content.inputID)
    const inputID2 = useSelector(state  => state.content.inputID2)

    const defaultCloseHandler = () => {
        dispatch(actionCreators.setModal(null,null))
        onClose && onClose()
    }

    const closeHandler = (event, reason) => {
        console.log('[Modal] onClose', {event: event, reason: reason, inputID, inputID2})
        reason === 'backdropClick' && defaultCloseHandler()
        reason === 'escapeKeyDown' && !inputID && !inputID2 && defaultCloseHandler()
        if(inputID2){
            dispatch(actionCreators.setInput(inputID,null))
        }
    }

    return (
        <MaterialModal open={true}
            onBackdropClick={defaultCloseHandler} 
            onClose={closeHandler} 
            closeAfterTransition={true} 
            BackdropProps={{style: updatedStyle}}>
            {x && y ? <AbsoluteContainer x={x} y={y}>{props.children}</AbsoluteContainer> 
            : <FlexContainer><Animation animation='appear'>{props.children}</Animation></FlexContainer>}
        </MaterialModal>
    )
}

export default Modal

Modal.propTypes = {
    animation: PropTypes.bool
}